import { useMemo } from 'react';
import createFormatter from '../core/use-intl.esm3.js';
import useIntlContext from './use-intl.esm11.js';

function useFormatter() {
  var _useIntlContext = useIntlContext(),
    formats = _useIntlContext.formats,
    locale = _useIntlContext.locale,
    globalNow = _useIntlContext.now,
    onError = _useIntlContext.onError,
    timeZone = _useIntlContext.timeZone;
  return useMemo(function () {
    return createFormatter({
      formats: formats,
      locale: locale,
      now: globalNow,
      onError: onError,
      timeZone: timeZone
    });
  }, [formats, globalNow, locale, onError, timeZone]);
}

export { useFormatter as default };
//# sourceMappingURL=use-intl.esm7.js.map
